export async function getAuthProvider() {
    throw new Error('Server auth providers are not process-global. Use createWalletClient({ keypair }) and call that client\'s methods.');
}
//# sourceMappingURL=index.js.map